module.exports = __webpack_public_path__ + "static/media/add-to-inbox.6db42a55.png";